import {
	Button,
	FormItem,
	SecretValueInput
} from "client/Components";
import {
	ReactElement
} from "react";
import { localize } from "client_legacy/ndaw/culture";
import styles from "./TokenInput.module.less";

export type TokenInputProps = {
	tokenLabel: string;
	hasAToken: boolean;
	onRegenerateToken(): void;
};

export const TokenInput = (props: TokenInputProps): ReactElement => {
	const {
		tokenLabel,
		hasAToken,
		onRegenerateToken
	} = props;

	return (
		<FormItem label={tokenLabel}>
			<div className={styles.inputWithButton}>
				<div className={styles.inputWrapper}>
					<SecretValueInput
						value={{
							containsNewValue: false,
							value: null
						}}
						containsInitialValue={hasAToken}
						attachedOn={hasAToken
							? "right"
							: undefined}
						isDisabled
						trackingId="authentication-token-placeholder"
					/>
				</div>
				{hasAToken && (
					<Button
						kind="secondary"
						text={localize("_Regenerate")}
						attachedOn="left"
						onClick={onRegenerateToken}
						trackingId="regenerate-new-token-button"
					/>
				)}
			</div>
		</FormItem>
	);
};
TokenInput.displayName = "TokenInput";